import { render, staticRenderFns } from "./FormInputSize.vue?vue&type=template&id=e9e6adfc&"
import script from "./FormInputSize.vue?vue&type=script&lang=js&"
export * from "./FormInputSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports